import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface ArticleStatusBadgeProps {
  publishedAt: string | null;
  className?: string;
}

const STATUS_CONFIG = {
  published: {
    label: "발행됨",
    variant: "default" as const,
    className: "bg-green-100 text-green-800 border-green-300",
  },
  draft: {
    label: "임시저장",
    variant: "outline" as const,
    className: "bg-gray-50 text-gray-700 border-gray-300",
  },
};

export function ArticleStatusBadge({
  publishedAt,
  className,
}: ArticleStatusBadgeProps) {
  const config = publishedAt ? STATUS_CONFIG.published : STATUS_CONFIG.draft;

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
